import RetailCampaignForm from "components/Form/RetailCampaignForm";

const CreateCampaignPage = () => <RetailCampaignForm />;

export default CreateCampaignPage;
